import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import level0instr from "../images/level0/level0instr.png"
import instrLink from "../images/level0/instrLink.png"
import level0Task0 from '../solutionxml/level0Task0'
import BlocklyComponent, { Block, Value, Field, Shadow } from '../Blockly';
import fulltoolbox from '../toolboxes/fulltoolbox';
import level5xml from '../solutionxml/level5xml'

const level5 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 5: Functions 
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: Print out your name 5 times using a function. 
Hint: This is very similar to printing out “hello world” as in our example above. Think about what you might need to change in your function to print out your name 5 times. 

        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
      </BlocklyComponent>
  </div>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Create a function called “word_count” that counts how many letters there are in the word “Philadelphia” 
        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Create a function called “last_car”  that tells you what car is parked last in the street (here’s a list of the cars parked in the street: [Toyota, Nissan, Kia])
        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
     >
      </BlocklyComponent>
  </div>
  <br></br>
  </main>
  
  </div>
  );
}
  
export default level5;